import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DsyListElement } from '../../../../../models/dsy-list-element.model';
import { DATE_PICKER_OPTIONS, DateOption } from '../../../../../models/filters.model';
import { ProgramOrganizationType } from '../../../../../models/program-organization.model';
import { FiltersStore } from '../../../../../store/signal-stores/pd-filters.signal-store';
import { DatePickerComponent } from '../../../../shared/components/date-picker/date-picker.component';
import { SearchableDropdownComponent } from '../../../../shared/components/searchable-dropdown/searchable-dropdown.component';


@Component({
  selector: 'fdr-past-performance-ui-program-filters-panel',
  imports: [TranslateModule, DatePickerComponent, SearchableDropdownComponent],
  templateUrl: './program-filters-panel.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: contents' },
})
export class ProgramFiltersPanelComponent {
  readonly store = inject(FiltersStore);

  readonly programEntries = input.required<DsyListElement[]>();
  readonly productEntries = input.required<DsyListElement[]>();
  readonly showProductsCounterTag = input.required<boolean>();
  readonly dateResetToken = input.required<number>();
  readonly dropdownListConfig = { maxHeight: '300px' }
  readonly counterTagConfig = { variant: 'secondary' };
  readonly dateValidityChange = output<boolean>();

  readonly datesOptions = DATE_PICKER_OPTIONS;

  onDateChange(values: Date[]) {
    this.store.updateDateRange(ProgramOrganizationType.Program, DateOption.customPeriod, values[0], values[1]);
  }

  onSuggestionChange(option: DateOption) {
    this.store.updateDateRange(ProgramOrganizationType.Program, option);
  }

  onDateValidityChange(isValid: boolean) {
    this.dateValidityChange.emit(isValid);
  }
}
